export default __webpack_public_path__ + "static/media/link_broken.28c68cb2.svg";